import React from "react";
import { nextScheduleAsString } from "./utils";
import ControlPanel from "./ControlPanel";
import ToggleIcon from "../../Components/ToggleIcon";
import { useSocketClient } from "../../contexts/SocketClientProvider";
import useControlAttribute from "../../hooks/useControlAttribute";
import useModeColor, { TMode } from "../../hooks/useModeColor";
import { IControlChicken } from "./types";
import { IconSets } from "./IconSets";

interface IControlChickenProps {
  control: IControlChicken;
}

const ControlChicken = (props: IControlChickenProps) => {
  const { control } = props;
  const flapStatus = useControlAttribute(control, "flap_status");
  const nextSchedule = useControlAttribute(
    control,
    "next_schedule",
    control.next_schedule
  );
  const socketClient = useSocketClient();
  const iconName =
    flapStatus === "error"
      ? "error-outline"
      : flapStatus === "top"
        ? IconSets[control.icon_set_name].on
        : flapStatus === "bottom"
          ? IconSets[control.icon_set_name].off
          : "sync";
  const toggleFlapStatus = () => {
    if (["top", "bottom"].includes(flapStatus)) {
      socketClient.process_command({
        type: "control",
        id: control.id,
        command: "toggle",
        value: flapStatus === "top" ? "down" : "up",
      });
    }
  };
  const mode: TMode = control.is_enabled
    ? ["top", "down"].includes(flapStatus)
      ? "on"
      : "off"
    : "disabled";
  const iconColor = useModeColor(mode);

  return (
    <ControlPanel
      id={control.id}
      mode={mode}
      title={control.name}
      isToggle={true}
      state={nextScheduleAsString(nextSchedule)}
    >
      <ToggleIcon
        name={iconName}
        color={iconColor}
        onClick={toggleFlapStatus}
      />
    </ControlPanel>
  );
};

export default ControlChicken;
